import {
  Stack,
  Flex,
  Title,
  MantineTheme,
  useMantineTheme,
  Paper,
  StackProps,
  PaperProps,
} from "@mantine/core"
import { SuspenseWithErrorBoundary } from "../../../../-components/suspense"
import classes from "./index.module.css"

import { PropsWithChildren } from "react"
import { ellipsify } from "../../../../utils/ellipsify"
import { NavigateOptions } from "@tanstack/react-router"
import { Link } from "../../../../-components/link"
import { useBreakpoints } from "@/utils/use-breakpoints"

export interface DashboardCardProps extends PropsWithChildren, PaperProps {
  leftOfTitle?: React.ReactNode
  rightOfTitle?: React.ReactNode
  title?: string
  titleLinksTo?: NavigateOptions
  color?: (theme: MantineTheme) => string
  onClick?: () => void
  stackProps?: StackProps
}

export function DashboardCard({
  title,
  titleLinksTo,
  leftOfTitle,
  rightOfTitle,
  color,
  onClick,
  children,
  stackProps,
  ...props
}: DashboardCardProps) {
  const theme = useMantineTheme()
  const { xs } = useBreakpoints()
  return (
    <Paper
      bg={color && color(theme)}
      withBorder
      p="sm"
      radius="md"
      shadow="sm"
      miw={0}
      mih={400}
      mah={xs ? undefined : "45vh"}
      style={{ alignItems: "center" }}
      className={onClick ? classes.cardButton : undefined}
      onClick={onClick}
      {...props}
    >
      {
        <Stack h="100%" align="flex-start" {...stackProps}>
          {title ? (
            <Flex gap="xs" justify={"start"} w="100%" align="center">
              {leftOfTitle}

              {titleLinksTo ? (
                <Link
                  fw={700}
                  size="lg"
                  navigateOptions={titleLinksTo}
                  linkText={title}
                />
              ) : (
                <Title style={{ ...ellipsify }} order={4}>
                  {title}
                </Title>
              )}
              <div style={{ flexGrow: 1 }} />
              {rightOfTitle}
            </Flex>
          ) : null}
          <SuspenseWithErrorBoundary>{children}</SuspenseWithErrorBoundary>
        </Stack>
      }
    </Paper>
  )
}
